export class InputControlCheckBoxViewModel {
  public static createEmpty(): InputControlCheckBoxViewModel {
    return new InputControlCheckBoxViewModel();
  }
  constructor(
    public Id: number = 0,
    public IsChecked: boolean = false,
    public Label: string = '',
  ) { }
}
